import { useQuery, keepPreviousData } from "@tanstack/react-query";

import { fetchVideos } from "../../api/videos";

export function useFetchVideos({
  page = 1,
  pageSize = 10,
  status = "",
  processed = "",
  minMalfunctions = "",
  maxMalfunctions = "",
  startDate = "",
  endDate = "",
  unsolvedOnly = false,
  ordering = "-timestamp",
  search = "",
} = {}) {
  return useQuery({
    queryKey: [
      "videos",
      page,
      pageSize,
      status,
      processed,
      minMalfunctions,
      maxMalfunctions,
      startDate,
      endDate,
      unsolvedOnly,
      ordering,
      search,
    ],
    queryFn: () =>
      fetchVideos({
        page,
        pageSize,
        status,
        processed,
        minMalfunctions,
        maxMalfunctions,
        startDate,
        endDate,
        unsolvedOnly,
        ordering,
        search,
      }),
    onError: (err) => console.error("Error loading videos:", err),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
  });
}